"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../../hyperapp");
const uikit_e_field_1 = require("../../common/components/uikit-e-field");
const uikit_e_list_1 = require("../../common/components/uikit-e-list");
const uikit_e_list_item_1 = require("../../common/components/uikit-e-list-item");
exports.ImageVisibilitySwitch = ({ translate, imageVisibilityState, onImageVisibilityStateChange, }) => (hyperapp_1.h(uikit_e_field_1.UiKitEField, null,
    hyperapp_1.h(uikit_e_list_1.UiKitEList, null, [
        {
            value: 'inherit',
            label: translate('imageVisibilityInherit'),
        },
        {
            value: 'hideImage',
            label: translate('imageVisibilityHideImage'),
        },
        {
            value: 'showImage',
            label: translate('imageVisibilityShowImage'),
        },
    ].map(option => (hyperapp_1.h(uikit_e_list_item_1.UiKitEListItem, null,
        hyperapp_1.h("input", { className: "e-radio e-radio-block", value: option.value, id: `imageVisibilitySwitch_${option.value}`, name: "imageVisibilitySwitch", type: "radio", checked: imageVisibilityState === option.value, onchange: e => onImageVisibilityStateChange(e.target['value']) }),
        hyperapp_1.h("label", { for: `imageVisibilitySwitch_${option.value}` }, option.label)))))));
//# sourceMappingURL=image-visibility-switch.js.map